import { numberToPrettyString } from '@cian/utils';

export function getUniqueTotalCountTitle(totalUniqueOffersLen: number): string {
  if (!totalUniqueOffersLen) {
    return '';
  }

  return `, из них ${numberToPrettyString(totalUniqueOffersLen)} только на ЦИАН`;
}
